import { useWidgetData } from '../useWidgetData'

import { ReportInterval } from '../../../types/report/report'
import { PeakHoursWidget } from '../../../types/widget/widget'
import { createReportQuery } from '../../../utils/reportUtils'

export const usePeakHoursWidget = (interval: ReportInterval) =>
  useWidgetData<PeakHoursWidget>(
    `peak-hours?${createReportQuery(interval)}`
  )
